export default "__VITE_ASSET__ef70b13e__"